import React, { Component } from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import axios from 'axios';
import { Col, Row } from 'react-bootstrap';

import BasicTemplate from './BasicTemplate.js';
import GreetingsModal from './GreetingsModal.js';

require(`../assets/${process.env.PAGE}/css/components/Disapproved.css`)

const FINANCIAL_ENTITIES = {
	'bcra': {
		'name': 'Banco Central de la República Argentina',
		'url':'http://www.bcra.gov.ar',
	},
	'rentas': {
		'name':'ATM',
		'url': 'https://www.atm.mendoza.gov.ar',
	},
	'ftyc': {
		'name': 'Administradora Provincial del FTyC',
		'url':'https://www.ftyc.gob.ar/',
	},
	'poder_judicial_rda': {
		'name': 'Poder Judicial',
		'url':'http://www.jus.mendoza.gov.ar/',
	},
	'poder_judicial_ju': {
		'name': 'Poder Judicial',
		'url':'http://www.jus.mendoza.gov.ar/',
	},
}

class Disapproved extends Component  {

	constructor(props){
		super(props);
		this.state = {
			subscriber: {
				rejected_sources: [],
			    children: [],
			  }
		}

		this.renderDebtDetail = this.renderDebtDetail.bind(this);
	  }

	componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/steps/params`, config).then((response)=> {
            this.setState({
                subscriber: response.data.subscriber,
            });
        });
    }

	renderDebtDetail(subscription){
		return (
			<Row>
				<Col className="text-center rejected-reason" xs={12} md={12} lg={12}>
					<p className='red-text'>{`CUIT (${subscription.CUIL})`}</p>
				</Col>
				{subscription.rejected_sources.filter((source) => {
					if (source === 'poder_judicial_rda') {
						if (subscription.rejected_sources.includes('poder_judicial_ju')) {
							return false;
						}
					}

					return Object.keys(FINANCIAL_ENTITIES).includes(source);

				}).map((source) => {
					return (
						<Col className="text-center" xs={12} md={12} lg={12}>
							<a className='btn btn-source' target="_blank" href={FINANCIAL_ENTITIES[source]['url']}>{FINANCIAL_ENTITIES[source]['name']}</a>
						</Col>
					);
				})}
			</Row>
		);
	}

	render() {

		const { subscriber } = this.state;

		const subscriptionDebtDetail = subscriber.rejected_sources.filter(s => s !== 'form').length > 0;
		const childrenDebtDetail = subscriber.children && subscriber.children.filter(c => c.rejected_sources.filter(s => s !== 'form').length > 0).length > 0;

		const subscriberDebt = subscriber.rejected_sources.filter(s => s !== 'form').length > 0 && this.renderDebtDetail(subscriber);
		const subscriptionsDebt = subscriber.children && subscriber.children.length > 0 && subscriber.children.map(subscription => {
			return this.renderDebtDetail(subscription);
		})


		return (
			<BasicTemplate>
				<FormattedHTMLMessage id="app.disapproved" description=" "/>
				{(subscriptionDebtDetail || childrenDebtDetail) && <Row><Col><FormattedHTMLMessage id="app.disapproved_description" description=" "/></Col></Row>}
				{subscriberDebt}
				{subscriptionsDebt}
				<GreetingsModal/>
			</BasicTemplate>
		);
	}

}

export default Disapproved;


/** WEBPACK FOOTER **
 ** ./src/components/Disapproved.js
 **/